<template>
  <HeadTitle
    title="Vacaciones"
    description="Lista de las solicitudes de vacaciones y sus estados de aprobación"
  />
  <divider></divider>
  <VacationSummaryToolbar
    :vacation-balance="vacationBalance"
    @new-request="openNewRequestDialog"
  />
  <VacationRequestsTable
    :vacations="vacations"
    :filters="filters"
    :expanded-rows="expandedRows"
    :statuses="statuses"
    :company-code="company?.code"
    @update:filters="onFiltersUpdate"
    @update:expandedRows="onExpandedRowsUpdate"
    @row-expand="onRowExpand"
    @view-receipt="onVacationReceipt"
    @download-attachment="downloadAttachment"
    @delete-request="onDeleteRequest"
  />
  <VacationRequestDialog
    :visible="vacationDialog"
    :vacation="vacation"
    :allow-payed-vacations="allowPayedVacations"
    :submitted="submitted"
    :disabled-days="getDisabledDays"
    :disabled-dates="getDisabledDates"
    :badge-resolver="getBadge"
    :is-valid-to-save="isValidToSave"
    :allow-negative-p-t-o-balance="allowNegativePTOBalance"
    :vacation-balance="vacationBalance"
    :pending-balance="pendingBalance"
    @update:visible="setVacationDialogVisibility"
    @update:vacation="updateVacation"
    @save-request="saveRequest"
    @cancel="hideDialog"
    @select-file="saveFile"
    @remove-file="removeFile"
    @calculate-date-end="calculateDateEnd"
  />
</template>
<script setup lang="ts">
  import { computed } from 'vue'
  import { useUserStore } from '@/store'
  import { storeToRefs } from 'pinia'
  import HeadTitle from '@/shared/components/HeadTitle.vue'
  import VacationSummaryToolbar from '@/modules/employees/components/VacationSummaryToolbar.vue'
  import VacationRequestsTable from '@/modules/employees/components/VacationRequestsTable.vue'
  import VacationRequestDialog from '@/modules/employees/components/VacationRequestDialog.vue'
  import { useVacations } from '@/modules/employees/composables/useVacations'

  const { user, company } = storeToRefs(useUserStore())

  const {
    vacation,
    vacations,
    statuses,
    vacationDialog,
    submitted,
    vacationBalance,
    allowPayedVacations,
    allowNegativePTOBalance,
    filters,
    expandedRows,
    getDisabledDays,
    getDisabledDates,
    getBadge,
    isValidToSave,
    pendingBalance,
    onFiltersUpdate,
    onExpandedRowsUpdate,
    setVacationDialogVisibility,
    openNewRequestDialog,
    onRowExpand,
    onVacationReceipt,
    downloadAttachment,
    onDeleteRequest,
    saveFile,
    removeFile,
    calculateDateEnd,
    saveRequest,
    hideDialog,
    updateVacation,
  } = useVacations({
    employeeId: computed(() => user.value?.employeeId),
    userId: computed(() => user.value?.id),
    autoLoad: true,
  })
</script>
